import React from 'react';
import { Tooltip, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

const PriceChip = styled(Chip)({
  backgroundColor: '#DCFCE7',
  color: '#166534',
  fontWeight: 600,
  '& .MuiChip-label': {
    padding: '0 12px'
  }
});

interface PriceDisplayProps {
  basePrice: string;
  zipCode: string;
  serviceCode: string;
}

const formatCurrency = (value: string | number) => {
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  return numValue.toLocaleString('pt-PT', {
    style: 'currency',
    currency: 'EUR'
  });
};

export const calculatePrice = (basePrice: string, zipCode: string, serviceCode: string) => {
  const numPrice = parseFloat(basePrice);
  
  // Não aplica IVA se:
  // 1. Código postal começa com 9 (Açores/Madeira)
  // 2. Código postal não está no formato XXXX-XXX
  // 3. Serviço é EASYVA
  if (
    zipCode.startsWith('9') || 
    !/^\d{4}-\d{3}$/.test(zipCode) || 
    serviceCode === 'EASYVA'
  ) {
    return {
      displayPrice: formatCurrency(numPrice),
      hasVAT: false,
      basePrice: numPrice,
      totalPrice: numPrice
    };
  }

  // Adiciona 23% de IVA
  const priceWithVAT = numPrice * 1.23;
  return {
    displayPrice: formatCurrency(priceWithVAT),
    hasVAT: true,
    basePrice: numPrice,
    totalPrice: priceWithVAT
  };
};

export default function PriceDisplay({ basePrice, zipCode, serviceCode }: PriceDisplayProps) {
  const priceInfo = calculatePrice(basePrice, zipCode, serviceCode);
  
  const tooltipTitle = priceInfo.hasVAT 
    ? `Valor base: ${formatCurrency(priceInfo.basePrice)} + IVA (23%)`
    : 'IVA não aplicável';

  return (
    <Tooltip title={tooltipTitle} arrow>
      <PriceChip label={priceInfo.displayPrice} />
    </Tooltip>
  );
}
